import { t } from "@lingui/macro";
import { DownloadSimpleIcon } from "@phosphor-icons/react";
import { useEffect, useRef, useState } from "react";

import { useDialog } from "@/client/stores/dialog";

import { FontControls } from "./font-controls";
import { PalettePicker } from "./palette-picker";
import { PreviewPageLayoutToggle, PreviewToolbar } from "./preview-toolbar";

export const AppearanceToolbar = () => {
  const { open } = useDialog("confirm-download");
  const ref = useRef<HTMLDivElement>(null);
  const [wide, setWide] = useState(false);
  useEffect(() => {
    if (!ref.current) return;
    const observer = new ResizeObserver(([entry]) => setWide(entry.contentRect.width >= 840));
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return (
    <div
      ref={ref}
      className="shrink-0 border-t border-slate-200 bg-white p-2.5 pb-[max(0.625rem,env(safe-area-inset-bottom))]"
    >
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="flex min-w-0 flex-wrap items-center gap-2">
          <PalettePicker includeTypography={!wide} />
          {wide && <FontControls />}
          <PreviewToolbar />
          <PreviewPageLayoutToggle />
        </div>
        <button
          type="button"
          onClick={() => open("read")}
          className={`${wide ? "w-auto" : "w-full"} inline-flex min-h-11 shrink-0 items-center justify-center gap-2 rounded-xl bg-emerald-600 px-4 text-xs font-semibold text-white shadow-sm transition hover:bg-emerald-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 focus-visible:ring-offset-2`}
        >
          <DownloadSimpleIcon aria-hidden size={18} />
          {t`Télécharger le CV (.pdf)`}
        </button>
      </div>
    </div>
  );
};
